(function () {
  var SLUG_ALIASES = {
    'hen-party': 'bachelorette-party'
  };

  function normalizeSlug(slug) {
    return SLUG_ALIASES[slug] || slug;
  }

  function initEventDetailHero(root) {
    if (!root || root.dataset.amcEdhInit === 'true') return;
    root.dataset.amcEdhInit = 'true';

    var tabs = root.querySelectorAll('[data-amc-edh-tab]');
    var panels = root.querySelectorAll('[data-amc-edh-panel]');
    if (!tabs.length || !panels.length) return;

    var tablist = root.querySelector('.amc-edh__tabs');
    var section = root.closest('.shopify-section') || root;

    function indexForSlug(slug) {
      if (!slug) return -1;

      var normalized = normalizeSlug(slug);
      var index = -1;
      tabs.forEach(function (tab, i) {
        if (tab.dataset.tabSlug === normalized) index = i;
      });
      return index;
    }

    function scrollHeroIntoView() {
      if (typeof section.scrollIntoView !== 'function') return;

      requestAnimationFrame(function () {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function scrollActiveTabIntoView(tab) {
      if (!tab || !tablist) return;

      var canScrollHoriz = tablist.scrollWidth > tablist.clientWidth + 1;
      if (!canScrollHoriz) return;

      var tabLeft = tab.offsetLeft;
      var tabWidth = tab.offsetWidth;
      var listWidth = tablist.clientWidth;
      var targetLeft = tabLeft - (listWidth - tabWidth) / 2;

      tablist.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth',
      });
    }

    function activate(index, options) {
      options = options || {};

      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel, i) {
        panel.hidden = i !== index;
      });

      var activeTab = tabs[index];
      if (activeTab) {
        scrollActiveTabIntoView(activeTab);
      }

      if (options.scrollHero) scrollHeroIntoView();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        var slug = tab.dataset.tabSlug;
        if (slug && window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + slug);
        }
        activate(index);
        if (typeof tab.focus === 'function') {
          tab.focus({ preventScroll: true });
        }
      });

      tab.addEventListener('keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (next !== index) {
          event.preventDefault();
          if (typeof tabs[next].focus === 'function') {
            tabs[next].focus({ preventScroll: true });
          }
          activate(next);
        }
      });
    });

    function applyHash(scrollHero) {
      var hash = window.location.hash.replace('#', '');
      if (!hash) {
        activate(0);
        return;
      }

      var index = indexForSlug(hash);
      // Unknown hashes (e.g. #event-inquiry-form from BOOK NOW) must not
      // reset the tab or scroll the hero to the top — that stole the first click.
      if (index < 0) return;

      activate(index, { scrollHero: !!scrollHero });
    }

    applyHash(!!window.location.hash);

    window.addEventListener('hashchange', function () {
      applyHash(true);
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted || window.location.hash) {
        applyHash(!!window.location.hash);
      }
    });
  }

  function scan() {
    document.querySelectorAll('[data-amc-edh]').forEach(initEventDetailHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-amc-edh]');
    if (root) initEventDetailHero(root);
  });
})();
